import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { globalConfig } from 'applicationConfig';

const SCRIPT_ELEMENT_ID = '_paypal_checkout.element.id';
const scriptUrl = 'https://www.paypalobjects.com/api/checkout.js';
let PayPalButton = null;

const environment = globalConfig.PAYPAL_ENVIRONMENT;
const CREATE_PAYMENT_URL = globalConfig.PAYPAL_CREATE_PAYMENT_URL;
const EXECUTE_PAYMENT_URL = globalConfig.PAYPAL_EXECUTE_PAYMENT_URL;

class PaypalCheckout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadedPayPal: false
    };
  }

  componentWillMount() {
    const setLoadedPaypal = () => {
      if (window.paypal) {
        PayPalButton = window.paypal.Button.driver('react', { React, ReactDOM });
        this.setState({ loadedPayPal: true });
      }
    };

    if (!document.getElementById(SCRIPT_ELEMENT_ID)) {
      const head = document.head || document.getElementsByTagName('head')[0];
      const script = document.createElement('script');
      script.setAttribute('data-version-4', '');
      //script.setAttribute('data-log-level', 'info');
      script.id = SCRIPT_ELEMENT_ID;
      script.src = scriptUrl;

      script.onerror = (oError) => {
        throw new URIError(`The script ${oError.target.src} is not accessible.`);
      };

      script.onload = setLoadedPaypal.bind(this);
      head.appendChild(script);
    } else {
      setLoadedPaypal();
    }
  }

  payment(data, actions) {
    const { userId, orderId, paymentCheckUrl = CREATE_PAYMENT_URL } = this.props.createParams;

    return window.paypal
      .request({
        method: 'post',
        url: paymentCheckUrl,
        json: {
          OrderID: orderId,
          UserID: userId
        }
      })
      .then((data) => data.OrderID || data.id)
      .catch((error) => {
        console.log(error);
        console.log(error.stack);
        console.log(error.response);
        alert(error.stack);
      });
  }

  onAuthorize(data, actions) {
    const onPaymentSuccess = this.props.onExecutePaymentSuccess;
    return window.paypal
      .request({
        method: 'post',
        url: EXECUTE_PAYMENT_URL,
        json: {
          Token: data.paymentToken,
          PaymentID: data.paymentID,
          PayerID: data.payerID
        }
      })
      .then(onPaymentSuccess)
      .catch((error) => {
        console.log(error);
        alert(error.stack);
      });
  }

  render() {
    const style = {
      label: 'generic',
      fundingicons: false, // optional
      branding: true, // optional
      size: 'small', // small | medium | large | responsive
      shape: 'pill', // pill | rect
      color: 'gold' // gold | blue | silve | black
    };

    return (
      <div className="paypal-checkout-btn-wrap">
        {this.state.loadedPayPal && (
          <PayPalButton
            style={style}
            commit={true}
            env={environment}
            payment={(data, actions) => this.payment(data, actions)}
            onAuthorize={(data, actions) => this.onAuthorize(data, actions)}
          />
        )}
      </div>
    );
  }
}

export default PaypalCheckout;



// WEBPACK FOOTER //
// ./src/common/components/PaypalCheckout/PaypalCheckout.jsx